/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadSectionFileResponseDto
 */
export interface UploadSectionFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadSectionFileResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the UploadSectionFileResponseDto interface.
 */
export function instanceOfUploadSectionFileResponseDto(value: object): value is UploadSectionFileResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UploadSectionFileResponseDtoFromJSON(json: any): UploadSectionFileResponseDto {
    return UploadSectionFileResponseDtoFromJSONTyped(json, false);
}

export function UploadSectionFileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadSectionFileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function UploadSectionFileResponseDtoToJSON(json: any): UploadSectionFileResponseDto {
    return UploadSectionFileResponseDtoToJSONTyped(json, false);
}

export function UploadSectionFileResponseDtoToJSONTyped(value?: UploadSectionFileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

